import React, {Component} from 'react'
import Article from './article'


class Citations extends Component {


    render() {
        return (
            <div>
                <Article>
                    <p>Para citar o Nadúvida em seus trabalhos acadêmicos, leia primeiro a <a
                        href='/mini-dicionário/política-de-uso/'>Política de uso</a> , se concordar use:</p>
                    <p>Referência : http://www.naduvidacom.br , Acesso em: dia/mês/ano</p>
                </Article>
            </div>
        )

    }
}


export default Citations



// WEBPACK FOOTER //
// ./src/citations.jsx